/**
 * @file Frontend callable wrappers for backend-authoritative Ordering item mutations.
 */

import {
    changeOrderingListLifecycleCallable,
    createOrderingItemCallable,
    deleteOrderingItemCallable,
    saveOrderingItemCallable,
    updateOrderingItemStatusCallable,
} from "../../app/firebase/callables.js";

function unwrap(call) {
    return call.then((result) => result.data);
}

/**
 * Creates an Ordering item through the backend authority.
 * @param {object} payload Create-item payload.
 * @returns {Promise<object>} Result.
 */
export function createOrderingItem(payload) {
    return unwrap(createOrderingItemCallable(payload));
}

/**
 * Saves editable Ordering item fields through the backend authority.
 * @param {object} payload Item save payload.
 * @returns {Promise<object>} Result.
 */
export function saveOrderingItem(payload) {
    return unwrap(saveOrderingItemCallable(payload));
}

/**
 * Applies one Ordering status transition through the backend authority.
 * @param {object} payload Status payload.
 * @returns {Promise<object>} Result.
 */
export function updateOrderingItemStatus(payload) {
    return unwrap(updateOrderingItemStatusCallable(payload));
}

/**
 * Deletes an Ordering item and its related backend-owned data.
 * @param {object} payload Delete-item payload.
 * @returns {Promise<object>} Result.
 */
export function deleteOrderingItem(payload) {
    return unwrap(deleteOrderingItemCallable(payload));
}

/**
 * Applies an admin-owned Ordering list archive, restore, or delete action.
 * @param {object} payload Lifecycle payload.
 * @returns {Promise<object>} Result including authoritative Ordering lists.
 */
export function changeOrderingListLifecycle(payload) {
    return unwrap(changeOrderingListLifecycleCallable(payload));
}
